import React from "react";
import { firestore } from '../firebase.js';
import '../Styles/Sass/ViewMyJobsCard.scss';

function ViewMyJobsCard(props) {
  const [currentJob, setCurrentJob] = React.useState({});
  const [currentJobAuthor, setCurrentJobAuthor] = React.useState('');

  React.useEffect(() => {
    getJobDetail();
  }, []);

  const getJobDetail = () => {
    firestore.collection('jobs').doc(props.jobId).get()
      .then(res => {
        let job = res.data();
        setCurrentJob(job);
        firestore.collection('users').doc(job.postedBy).get()
          .then(res => {
            setCurrentJobAuthor(res.data().name);
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      });
  }

  return (
    <li className='viewMyJobsCard'>
      <h4 className='viewMyJobsCard__name'>Posted by: {currentJobAuthor}</h4>
      <h5 className='viewMyJobsCard__headline'>{currentJob.headline}</h5>
      <p className='viewMyJobsCard__text viewMyJobsCard__text--description'>{currentJob.description}</p>
      <p className='viewMyJobsCard__text viewMyJobsCard__text--status'>
        {
          props.status.charAt(0).toUpperCase() + props.status.slice(1)
        }
      </p>
      <div className='viewMyJobsCard__subBox'>
        <p className='viewMyJobsCard__rate'>${currentJob.rate} per hour</p>
        <p className='viewMyJobsCard__location'>{currentJob.city} | {currentJob.postal} | {currentJob.province}</p>
      </div>
    </li>
  );
}

export default ViewMyJobsCard;